import { PropsWithChildren, useEffect, useId, useLayoutEffect, useRef } from 'react';
import { createDurationVitalAttempt } from './createDurationVitalAttempt';

export const APPLICATION_SUBMIT_TO_DECISION_VITAL = 'application.submit_to_decision';

const tracker = createDurationVitalAttempt(APPLICATION_SUBMIT_TO_DECISION_VITAL);

export const reportActiveApplicationSubmitToDecisionOutcome = tracker.reportActive;
export const resetApplicationSubmitToDecisionAttempts = tracker.reset;

interface ApplicationSubmitToDecisionProviderProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

export const ApplicationSubmitToDecisionProvider = ({
    context,
    children,
}: ApplicationSubmitToDecisionProviderProps) => {
    const instanceId = useId();
    const startedAtRef = useRef(Date.now());
    const contextRef = useRef(context);
    contextRef.current = context;

    useLayoutEffect(() => {
        tracker.register(instanceId, startedAtRef.current, contextRef.current);
        tracker.updateContext(instanceId, contextRef.current);
    }, [instanceId, context]);

    useEffect(() => {
        return () => {
            tracker.scheduleAbandon(instanceId);
        };
    }, [instanceId]);

    return children;
};

export interface ApplicationSubmitToDecisionGateProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

/** Place around terminal decision UI so the vital excludes reviewing/spinner states. */
export const ApplicationSubmitToDecisionGate = ({
    context,
    children,
}: ApplicationSubmitToDecisionGateProps) => {
    const reportContextRef = useRef(context);
    reportContextRef.current = context;

    useEffect(() => {
        let cancelled = false;
        let outerFrameId = 0;
        let innerFrameId = 0;

        outerFrameId = requestAnimationFrame(() => {
            innerFrameId = requestAnimationFrame(() => {
                if (cancelled) {
                    return;
                }

                tracker.reportActive('success', reportContextRef.current);
            });
        });

        return () => {
            cancelled = true;
            cancelAnimationFrame(outerFrameId);
            cancelAnimationFrame(innerFrameId);
        };
    }, []);

    return children;
};

/** @deprecated Use ApplicationSubmitToDecisionGate */
export const ReportApplicationSubmitToDecision = ApplicationSubmitToDecisionGate;
